import React from 'react'

import { Formik } from 'formik'

import { Form, Col, Row, Button } from '_zari/core'

import * as FormGroups from './formGroups'
import * as Sections from './sections'

const MainForm = () => {
  const initialValues = React.useMemo(() => {
    return {
      _idSocio: '',
      nombreSocio: '',
      documentoSocio: '',
      sobrenombreSocio: '',
      _idTemaSeguimiento: '',
      mostrarDetalles: false
    }
  }, [])

  return (
    <>
      <Formik initialValues={initialValues}>
        {({ values, errors, touched, isSubmitting, setValues, setFieldValue, handleChange }) => (
          <Form>
            <Row>
              <Col md={6}>
                <FormGroups.SocioFormGroup iError={errors._idSocio} iValue={values._idSocio} setValues={setValues} values={values} />
                {values._idSocio && (
                  <>
                    <FormGroups.SobreNombreFormGroup
                      iValue={values.sobrenombreSocio}
                      vIdSocio={values._idSocio}
                      iError={errors.sobrenombreSocio}
                      fIsSubmitting={isSubmitting}
                      iTouched={touched.sobrenombreSocio}
                    />
                    <FormGroups.TemasSeguimientoFormGroup
                      vIdSocio={values._idSocio}
                      iError={errors._idTemaSeguimiento}
                      fIsSubmitting={isSubmitting}
                      iTouched={touched._idTemaSeguimiento}
                      setFieldValue={setFieldValue}
                      handleChange={handleChange}
                    />
                    {values._idTemaSeguimiento && (
                      <Row>
                        <Col md={12} className='text-right'>
                          <Button onClick={() => setFieldValue('mostrarDetalles', true)}>Continuar</Button>
                        </Col>
                      </Row>
                    )}
                  </>
                )}
                {values.mostrarDetalles && (
                  <>
                    <Sections.TablaDetallesSection idSeguimiento={values._idTemaSeguimiento} />
                  </>
                )}
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  )
}

export default React.memo(MainForm)
